module.exports = __webpack_public_path__ + "img/pdf.19bde34b.png";